<template>
  <v-select
    v-model="value"
    :options="options"
    :placeholder="locales[lang].sort.label"
    :filterable="false"
    :searchable="false"
    :clearable="false"
    @input="edited"
  >
    <template #selected-option="{ label }">
      <div>
        <span class="font-semibold">
          {{ locales[lang].sort.label }}
        </span>
        <span>{{ label }}</span>
      </div>
    </template>
    <template #open-indicator="{ attributes }">
      <span v-bind="attributes">
        <i class="text-gray-400 fal fa-chevron-down" />
      </span>
    </template>
  </v-select>
</template>

<script>
import bus from "../js/bus.js";

export default {
  props: ["lang", "locales"],
  data() {
    return {
      value: false,
    };
  },
  computed: {
    options() {
      let result = [];
      if (this.lang) {
        result = [
          {
            label: this.locales[this.lang].sort.relevance,
            orderBy: "relevance",
            order: "desc",
          },
          {
            label: this.locales[this.lang].sort.price_h_l,
            orderBy: "price",
            order: "desc",
          },
          {
            label: this.locales[this.lang].sort.price_l_h,
            orderBy: "price",
            order: "asc",
          },
        ];
      }
      return result;
    },
  },
  mounted() {
    bus.$on("updateData", (item) => {
      if (item.id === "sort") {
        if (item.data.orderBy === "relevance") {
          this.value = {
            label: this.locales[this.lang].sort.relevance,
            order: item.data.order,
            orderBy: item.data.orderBy,
          };
        }

        if (item.data.order === "desc" && item.data.orderBy === "price") {
          this.value = {
            label: this.locales[this.lang].sort.price_h_l,
            order: item.data.order,
            orderBy: item.data.orderBy,
          };
        }

        if (item.data.order === "asc" && item.data.orderBy === "price") {
          this.value = {
            label: this.locales[this.lang].sort.price_l_h,
            order: item.data.order,
            orderBy: item.data.orderBy,
          };
        }

        if (item.data.order === "desc" && item.data.orderBy === "date") {
          this.value = {
            label: this.locales[this.lang].sort.date_h_l,
            order: item.data.order,
            orderBy: item.data.orderBy,
          };
        }

        if (item.data.order === "asc" && item.data.orderBy === "date") {
          this.value = {
            label: this.locales[this.lang].sort.date_l_h,
            order: item.data.order,
            orderBy: item.data.orderBy,
          };
        }
      }
    });
  },
  methods: {
    edited() {
      bus.$emit("setData", {
        id: "sort",
        data: this.value,
      });
    },
  },
};
</script>

